import React from "react";
import AddByKeyConditionOption from "./addByKeyCondition";
import "./index.css";
import SearchByUsers from "./searchByUsers";

function SelectKeyConditionDefinitionMethod({ setCurrentStepState, setDisplayLabels }) {
  return (
    <div className="key-condition-method-selection">
      <AddByKeyConditionOption
        setCurrentStepState={setCurrentStepState}
        setDisplayLabels={setDisplayLabels}
      />
      <div className="key-condition-or-text">OR</div>
      <SearchByUsers
        setCurrentStepState={setCurrentStepState}
        setDisplayLabels={setDisplayLabels}
      />
    </div>
  );
}

export default SelectKeyConditionDefinitionMethod;
